import React from "react";
import { EmptyContainer, EmptyImage, EmptyText } from "./EmptyCard.style";
import { useTranslation } from "react-i18next";

const EmptyCard = ({ minHeight }) => {
  const { t } = useTranslation();

  return (
    <EmptyContainer minHeight={minHeight}>
      <EmptyImage />
      <EmptyText>{t("common.notResultFound")}</EmptyText>
    </EmptyContainer>
  );
};

export default EmptyCard;
